<template>
  <div class="relative">
    <picture>
      <source v-if="content.cover" :srcset="content.cover.url" media="(min-width: 768px)" />
      <img
        v-if="content.cover_mobile || content.cover"
        :src="content.cover_mobile?.url ?? content.cover?.url"
        class="absolute z-[-1] size-full object-cover"
        :alt="content.cover_mobile?.alt_text ?? content.cover?.alt_text ?? undefined"
      />
    </picture>
    <div class="py-28 text-center" :class="content.cover || content.cover_mobile ? '' : 'bg-primary-100'">
      <UiNarrowContainer class="space-y-4">
        <UiHeading type="h4" class="text-primary-400">{{ content.subtitle }}</UiHeading>
        <UiHeading type="h1">{{ content.title }}</UiHeading>
        <PagePromoBannerCountdown v-if="content.expired_at" :target-date="content.expired_at" />
        <UiButton
          v-if="content.cta"
          :id="`page-promo-banner-${content.id}-cta`"
          :variant="content.cta.type"
          @click="goTo(content.cta.url, { external: true })"
        >
          {{ content.cta.title }}
        </UiButton>
      </UiNarrowContainer>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PagePromoBannerProps } from '~/components/Page/types';

const goTo = useGoTo();

defineProps<PagePromoBannerProps>();
</script>
